module.exports = __webpack_public_path__ + "img/bim.ea6c2acf.png";